import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { StoreWorkingTime } from '../../../models/store/StoreWorkingTime';
import { StoreWorkingHoursResponse } from '../../../../interfaces/response/StoreResponses';

/**
 * An adapter converts store working time HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class StoreWorkingTimeAdapter implements Adapter<StoreWorkingTime> {

  /**
   * Converts store working time HTTP response to {@link StoreWorkingTime}.
   * @param item store working time HTTP response.
   */
  adapt(item: StoreWorkingHoursResponse): StoreWorkingTime {
    if (!item) {
      return null;
    }

    return new StoreWorkingTime(item.openingTime, item.closingTime);
  }
}
